import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { times } from "lodash-es";
import { useFormContext } from "react-hook-form";
import { v4 } from "uuid";

import { Button } from "src/base-components/Button";
import {
  DecisionTableOperators,
  MatrixTableEffect,
  MatrixTablePredicate,
} from "src/clients/flow-api";
import { MatrixTableNodeForm } from "src/matrixTableNode/MatrixTableNodeEditor";

export const Buttons = ({
  disabled,
  tableContainerRef,
}: {
  disabled: boolean;
  tableContainerRef: React.RefObject<HTMLDivElement>;
}) => {
  const { getValues, setValue } = useFormContext<MatrixTableNodeForm>();

  const handleAddColumn = () => {
    const columnPredicates = getValues("column_predicates");
    const gridEffects = getValues("grid_effects");
    const newGridEffects = gridEffects.map((rowEffects) => {
      return [
        ...rowEffects,
        {
          id: v4(),
          value: "",
        },
      ];
    });

    const lastColumnPredicate = columnPredicates[columnPredicates.length - 1];
    const lastOperator =
      lastColumnPredicate?.operator ?? DecisionTableOperators.EQ;
    const newColumnPredicate: MatrixTablePredicate = {
      id: v4(),
      value: "",
      operator: lastOperator,
    };

    setValue("column_predicates", [...columnPredicates, newColumnPredicate]);
    setValue("grid_effects", newGridEffects);

    // need to wait for the new column to be added to the table
    setTimeout(() => {
      tableContainerRef.current?.scrollTo({
        left: tableContainerRef.current?.scrollWidth,
        behavior: "smooth",
      });
    }, 0);
  };

  const handleAddRow = () => {
    const rowPredicates = getValues("row_predicates");
    const columnPredicates = getValues("column_predicates");
    const gridEffects = getValues("grid_effects");
    const newRowEffects: MatrixTableEffect[] = times(
      columnPredicates.length,
      () => ({
        id: v4(),
        value: "",
      }),
    );

    const lastRowPredicate = rowPredicates[rowPredicates.length - 1];
    const lastOperator =
      lastRowPredicate?.operator ?? DecisionTableOperators.EQ;
    const newRowPredicate: MatrixTablePredicate = {
      id: v4(),
      value: "",
      operator: lastOperator,
    };

    setValue("row_predicates", [...rowPredicates, newRowPredicate]);
    setValue("grid_effects", [...gridEffects, newRowEffects]);

    // need to wait for the new row to be added to the table
    setTimeout(() => {
      tableContainerRef.current?.scrollTo({
        top: tableContainerRef.current?.scrollHeight,
        behavior: "smooth",
      });
    }, 0);
  };

  return (
    <div className="flex gap-2">
      <Button
        disabled={disabled}
        iconLeft={faPlus}
        size="sm"
        variant="secondary"
        onClick={handleAddRow}
      >
        Add row
      </Button>
      <Button
        disabled={disabled}
        iconLeft={faPlus}
        size="sm"
        variant="secondary"
        onClick={handleAddColumn}
      >
        Add column
      </Button>
    </div>
  );
};
